import { BOOKING_URL } from '@/constants';

const benefits = [
  {
    icon: 'ri-body-scan-line',
    title: 'Soulagement des douleurs',
    desc: 'Tensions musculaires, lombalgies, cervicales, courbatures — le motif le plus fréquent de consultation.',
  },
  {
    icon: 'ri-mental-health-line',
    title: 'Stress & détente',
    desc: 'Libère les tensions nerveuses et aide à retrouver un état de relaxation durable.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Circulation & vitalité',
    desc: 'Stimule la circulation locale et la sensation de légèreté après l’effort ou la fatigue.',
  },
  {
    icon: 'ri-run-line',
    title: 'Récupération sportive',
    desc: 'Accélère la récupération musculaire et réduit les courbatures post-entraînement.',
  },
];

export default function Benefits() {
  return (
    <section id="bienfaits" className="py-16 px-6 scroll-mt-[84px] bg-[#f6f3ec]">
      <div className="max-w-[1180px] mx-auto">
        <div className="max-w-[640px] mx-auto mb-10 text-center">
          <span className="text-[#0b6b52] text-xs font-semibold tracking-widest uppercase mb-3 block">
            Pourquoi choisir nos soins
          </span>
          <h2
            className="text-[clamp(34px,4.4vw,52px)] font-bold leading-[1.12] text-[#173029] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Les Bienfaits Thérapeutiques
          </h2>
          <p className="text-base leading-relaxed text-[#57534a] text-pretty">
            Le cupping accompagne le corps là où il a besoin de relâchement — sans promesse miracle, avec
            un protocole adapté à vous.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="bg-white border border-[#e8e2d4] rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(23,48,41,.08)]"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4 bg-[#0b6b52]/10">
                <i className={`${b.icon} text-[#0b6b52] text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-[#22201c] mb-2">{b.title}</h3>
              <p className="text-[13.5px] leading-relaxed text-[#8a8578] m-0">{b.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#0b6b52] rounded-3xl p-8 text-center text-white">
          <h3
            className="text-2xl md:text-3xl font-bold mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Prêt à essayer une séance ?
          </h3>
          <p className="text-white/80 mb-6 max-w-xl mx-auto text-sm leading-relaxed">
            Consultation initiale gratuite. Dites-nous ce qui vous amène — on vous guide vers le protocole
            adapté.
          </p>
          <a
            href={BOOKING_URL}
            className="inline-flex items-center gap-2 bg-white text-[#0b6b52] font-bold px-8 py-3 rounded-full hover:bg-[#e9f5ef] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            Demander un rendez-vous
          </a>
        </div>
      </div>
    </section>
  );
}
